export class FormationTopsUi {
  public constructor(init?: Partial<FormationTopsUi>) {
    this.tablePlotSelected = init && init.tablePlotSelected || 'table';
    this.northingUdtSelected = init && init.northingUdtSelected || 'northing';
  }
  tablePlotSelected: string;
  northingUdtSelected: string;
}
